import { difference, union } from 'lodash-es';

import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { restoreDeletedChapter } from '@editor2/services/conflictResolutionService';

export class BookChildrenReorderConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { initial, current, incoming } = conflict;
		const deletedOrMovedToInIncoming = difference(initial, incoming);
		const adedOrMovedFromInIncoming = difference(incoming, current);

		deletedOrMovedToInIncoming.map((chapterId) => {
			state.changes.chapters[chapterId] = [ChangesStatus.New];
		});
		adedOrMovedFromInIncoming.map((chapterId) => {
			state.changes.chapters[chapterId] = [ChangesStatus.Deleted];
		});

		state.initialCourse.chapters.ids = (conflict as ReorderConflict).incoming;
		state.chapters.ids = (conflict as ReorderConflict).current;
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		// 1 - discard current changes
		// 2 - apply incoming changes
		const { initial, current, incoming } = conflict as ReorderConflict;
		const deletedOrMovedToInCurrent = difference(initial, current);
		const addedOrMovedFromInCurrent = difference(current, initial);

		deletedOrMovedToInCurrent.map((chapterId) => {
			if (incoming.includes(chapterId)) {
				restoreDeletedChapter(state, chapterId);
			}
		});
		addedOrMovedFromInCurrent.map((chapterId) => {
			state.changes.chapters[chapterId] = [];
		});

		state.initialCourse.chapters.ids = incoming;
		state.chapters.ids = incoming;
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { initial, current, incoming } = conflict as ReorderConflict;
		const deletedCurrent = difference(initial, current);
		const deletedIncoming = difference(initial, incoming);
		const merged = union(current, incoming);

		deletedCurrent.map((id) => {
			state.chapters.entities[id] = state.initialCourse.chapters.entities[id];
			state.changes.chapters[id] = [];
		});
		deletedIncoming.map((id) => {
			if (current.includes(id)) {
				state.changes.chapters[id] = [ChangesStatus.New];
			}
		});

		state.initialCourse.chapters.ids = incoming;
		state.chapters.ids = merged;
	};
}
